import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MilitarySci = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M21.415.162c.36-.216.81-.216 1.17 0L39.71 10.457c.342.206.551.576.551.976v11.903a1.139 1.139 0 0 1-1.724.977L22 14.384 5.464 24.313a1.138 1.138 0 0 1-1.724-.977V11.433c0-.4.21-.77.552-.976L21.415.162ZM6.017 12.077v9.248l15.397-9.244c.361-.217.811-.217 1.172 0l15.397 9.244v-9.248L22 2.467l-15.983 9.61Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M21.415 19.688c.36-.217.81-.217 1.17 0l17.123 10.278c.343.206.552.577.552.977V42.86a1.139 1.139 0 0 1-1.725.976L22 33.896 5.465 43.837a1.138 1.138 0 0 1-1.725-.976V30.943c0-.4.21-.77.553-.977l17.121-10.279Zm-15.398 11.9v9.26l15.397-9.257c.36-.217.812-.217 1.173 0l15.396 9.257v-9.26L22 21.991 6.017 31.587Z"
  })));
});
MilitarySci.displayName = 'MilitarySci';
MilitarySci.defaultProps = {
  'aria-label': 'MilitarySci'
};
export default MilitarySci;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/MilitarySci.js
// module id = 3044
// module chunks = 11